import React from 'react';
import classNames from 'classnames';
import FontAwesomeIcon from '../Icon';
import { IContractFile } from '../../../public/APIContracts/APIContracts';
import './contract-file-tile.scss';

interface ContractFileTileProps {
  contractFile: IContractFile;
  onClick?: () => void;
  small?: boolean;
  active?: boolean;
}

const ContractFileTile = ({
  contractFile,
  onClick,
  small = false,
  active = false,
}: ContractFileTileProps) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const getCategoryDisplay = (category: string) => {
    return category.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const getFileIcon = (fileUrl: string) => {
    const extension: string = fileUrl.split('.').pop()?.toLowerCase();

    switch (extension) {
      case 'pdf':
        return 'file-pdf';
      case 'doc':
      case 'docx':
        return 'file-word';
      case 'xls':
      case 'xlsx':
        return 'file-excel';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'file-image';
      default:
        return 'file-contract';
    }
  };

  return (
    <div
      className={classNames('contract-file-tile', {
        'contract-file-tile--active': active,
        'contract-file-tile--small': small,
      })}
      onClick={() => onClick && onClick()}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {/* Top section with icon. */}
      <div className="contract-file-tile__header">
        <div className="contract-file-tile__icon">
          <FontAwesomeIcon
            weight="light"
            glyph={getFileIcon(contractFile.file_url)}
          />
        </div>
      </div>
      <div className="contract-file-tile__divider"></div>
      {/* Bottom section with details. */}
      <div className="contract-file-tile__details">
        <div className="contract-file-tile__name" title={contractFile.name}>
          {contractFile.name}
        </div>
        <div className="contract-file-tile__kind" title={contractFile.kind}>
          {contractFile.kind}
        </div>
        <div
          className="contract-file-tile__category"
          title={`Category: ${getCategoryDisplay(contractFile.category)}`}
        >
          {getCategoryDisplay(contractFile.category)}
        </div>
        <div
          className="contract-file-tile__date"
          title={`Created: ${formatDate(contractFile.created_at)}`}
        >
          Created: {formatDate(contractFile.created_at)}
        </div>
      </div>
    </div>
  );
};

export default ContractFileTile;
